module.exports = __webpack_public_path__ + "static/img/charge1.d3d54af1.png";